var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6984 26.2097L16.6822 26.2245L16.6668 26.2403L16.0009 26.9243L15.3847 26.2902L15.3692 26.2742L15.3528 26.2592C10.6771 21.987 7.7667 19.11 6.02079 16.7826C4.30316 14.4929 3.75 12.7849 3.75 10.8301C3.75 7.36313 6.31436 4.75 9.61431 4.75C11.441 4.75 13.3138 5.64902 14.5174 7.11845L14.5175 7.11868L15.42 8.21956L16 8.92715L16.58 8.21956L17.4825 7.11868L17.4826 7.1185C18.6863 5.6491 20.559 4.75 22.3857 4.75C25.6856 4.75 28.25 7.36313 28.25 10.8301C28.25 12.7852 27.6966 14.4934 25.9853 16.7768C24.2459 19.0978 21.3484 21.9624 16.6984 26.2097Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.91f9c10989e2547aeeedb5b116fb97a4.svg";
export { ForwardRef as ReactComponent };